import type { ComponentPropsWithoutRef } from 'react';
import { type DefaultTheme, styled } from 'styled-components';

import { Banner } from '../Banner';

import type { ToasterProps } from './types';

type BannerProps = ComponentPropsWithoutRef<typeof Banner>;

const borderLeftColorByVariant: Record<BannerProps['variant'], (theme: DefaultTheme) => string> = {
  error: theme => theme.designTokens.toastErrorBorderLeftColor,
  info: theme => theme.designTokens.toastInfoBorderLeftColor,
  success: theme => theme.designTokens.toastSuccessBorderLeftColor,
  warning: theme => theme.designTokens.toastWarningBorderLeftColor,
};

const StyledBanner = styled(Banner)`
  border: none;
  border-left-style: solid;
  border-left-width: ${({ theme }) => theme.designTokens.toastBorderLeftWidth};
  border-left-color: ${({ theme, variant }) => borderLeftColorByVariant[variant](theme)};
`;

const Toaster = styled.div<ToasterProps>`
  position: ${({ position }) => position};
  top: ${({ theme, top }) => top || theme.designTokens.toasterOffsetTop};
  right: ${({ theme }) => theme.designTokens.toasterOffsetRight};
  width: ${({ theme }) => theme.designTokens.toasterWidth};
  z-index: ${({ theme }) => theme.designTokens.toasterZIndex};
`;

export const Styled = {
  Banner: StyledBanner,
  Toaster,
};
